// Copyright (c) 2017 Deere & Company

import AuditClaim from './audit-claim';
import t from 'tcomb';

const AuditPreparation = t.struct({
    accounts: t.list(t.String, 'Accounts'),
    auditNumber: t.String,
    city: t.String,
    claims: t.list(AuditClaim, 'Claims'),
    leadAccount: t.String,
    leadAccountName: t.String,
    state: t.String,
    userSelectedClaimsMinimum: t.Number
}, {
    name: 'AuditPreparation',
    strict: true
});

export const getDefaultState = () => new AuditPreparation({
    accounts: [],
    auditNumber: '',
    city: '',
    claims: [],
    leadAccount: '',
    leadAccountName: '',
    state: '',
    userSelectedClaimsMinimum: 0
});

export default AuditPreparation;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/audit-preparation.js